import { PUBLIC_THERAPISTS_PAGE_SLUG } from '@/legacy-src/constants/locale.constants'
import { getTranslate } from '@/legacy-src/utilities/i18n'

import { Button, ButtonLink } from '@/src/domains/design-system/components/Button'
import { Text } from '@/src/domains/design-system/components/Text'
import { getLocalisedHref } from '@/src/domains/next-roots/utils/getLocalisedHref'
import { SelfAssessmentWizardCard } from '@/src/domains/self-assessments/components/SelfAssessmentWizard/SelfAssessmentWizardCard'
import { SelfAssessmentCta } from '@/src/domains/self-assessments/constants'
import type { SelfAssessmentResult } from '@/src/domains/self-assessments/schemas'

const hrefByCta: Record<SelfAssessmentCta, () => string> = {
  [SelfAssessmentCta.DIAGNOSIS]: () => getLocalisedHref('/diagnosis'),
  [SelfAssessmentCta.DEPRESSION_THERAPISTS]: () => `/${PUBLIC_THERAPISTS_PAGE_SLUG}?service=1&specialization=4`,
}

export interface SelfAssessmentWizardResultUIProps {
  result: SelfAssessmentResult
}

export const SelfAssessmentWizardResultUI = ({ result }: SelfAssessmentWizardResultUIProps) => {
  const { t } = getTranslate()

  return (
    <SelfAssessmentWizardCard heading={result.title} autoFocus>
      <Text element="p" variant="lg" className="text-petrol-500">
        {result.description}
      </Text>

      <div className="flex flex-col-reverse justify-between gap-4 tablet:flex-row">
        <ButtonLink size="medium" href={hrefByCta[result.cta]()}>
          {result.ctaLabel}
        </ButtonLink>

        <Button type="reset" size="medium" variant="secondary">
          {t('component.button.diagnosisAgain')}
        </Button>
      </div>
    </SelfAssessmentWizardCard>
  )
}
